import React from 'react';
import { Col, Row, Media } from 'reactstrap';
import { connect } from 'react-redux';
import { getVideoFiles } from '../../actions/VideoSongListAction';
import "react-table/react-table.css";
import VideoPlayer from '../VideoPlayer';
import { AjaxLoader } from '../AjaxLoader';
import GalleryHeader from '../GalleryHeader';
import { If } from 'rc-if-else';
import NoItemFound from '../NoItemFoundPage';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import AudioPlayer from '../AudioPlayer';
import { getVideoDirectoryName } from '../../actions/VideoDirectoryAction';

class VideoSongs extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            relativePath: '',
            relativeWebMPath: '',
            path: decodeURIComponent(this.props.location.search.substring(1)),
            directoryName: '',
            sectionName: '',
            selected: '',
            foundThumbnailPath: false,
            filteredList: [],
            videoPath: "",//Path for videos,
            videoFolderPath: "" //Path for videos folder
        }
    }

    componentWillMount() {
        if (this.state.path !== null && this.state.path !== "") {
            this.state.directoryName = this.state.path.split("/");
            this.state.foundThumbnailPath = true;
            this.props.getVideoFiles(this.state.path);
        }

        if (this.props.videoGalleryDirPath !== null) {
            this.props.getVideoDirectoryName(`${this.props.videoGalleryDirPath}/${this.state.directoryName[1]}`);
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.videoFiles !== prevProps.videoFiles || this.props.search !== prevProps.search || prevProps.videoDirectoryName !== this.props.videoDirectoryName) {
            const { videoDirectoryName, videoFiles } = this.props;
            const filteredList = videoDirectoryName.concat(videoFiles);
            if (this.props.search === "") {
                this.setState({ filteredList })
            } else {
                this.setState({ filteredList: filteredList.filter((name) => name.toLowerCase().includes(this.props.search.toLowerCase())) });
            }
        }
    }

    onSongChange(name) {
        const videoPath = `${this.state.path}/${this.state.videoPath}`;
        if (this.state.path !== undefined && this.state.path !== '') {
            this.setState({
                relativePath: `${videoPath}/${name}`,
                relativeWebMPath: `${videoPath}/WebM/${name.substr(0, name.lastIndexOf("."))}.webm`,
                selected: name
            });
        }
    }


    loadFolderContents = (name, action) => {
        if (this.state.path !== null && this.state.path !== "") {
            let path = this.state.path.split("/");
            path.shift();        //removing extra folder coming in the path
            path = path.join("/");

            let videosFilePath = this.state.videoPath;

            if (action == "I") {
                videosFilePath = `${this.state.videoPath}/${name}`;  //if Action I then add folder name to path
            }
            else {
                videosFilePath = videosFilePath.split('/');        //else remove one folder name in case of clicking back button
                videosFilePath.pop();
                videosFilePath = videosFilePath.join('/');
            }

            this.setState({ videoPath: videosFilePath })

            let videoDirectoryPath = `${path}/${videosFilePath}`;
            const finalVideosFilePath = `${this.state.path}/${videosFilePath}`;                    //path for video files
            this.props.getVideoFiles(finalVideosFilePath)

            this.setState(
                { videoFolderPath: `${this.props.videoGalleryDirPath}/${videoDirectoryPath}` },
                () => {
                    if (this.props.videoGalleryDirPath !== null) {
                        this.props.getVideoDirectoryName(this.state.videoFolderPath);
                    }
                }
            );
        }

    }

    isVideoFile(filename) {
        const videoExtensions = ['.mp4', '.avi', '.mov', '.mkv', '.flv', '.wmv', '.webm'];
        const extension = filename.slice(filename.lastIndexOf('.')).toLowerCase();
        return videoExtensions.includes(extension);
    }


    handleVideoOrFolderClick = (name) => {
        if (this.isVideoFile(name)) {
            this.onSongChange(name)
        }
        else {
            this.loadFolderContents(name, "I")
        }
    }

    showVideoFiles = () => {
        let fileType;
        const { filteredList } = this.state;
        if (filteredList !== null && filteredList.length > 0 && filteredList !== undefined) {
            return (
                <div>
                    <div className="d-flex justify-content-between align-item-center"><div>TITLE</div> {
                        this.state.videoPath && <span className="root-header d-flex align-items-center">
                            <FontAwesomeIcon className="fa-w-14" icon={faChevronLeft} />
                            <div className="pl-1" onClick={this.loadFolderContents}>Back</div>
                        </span>
                    }</div>
                    <div className="video-list">
                        {filteredList.map((name) => (
                            fileType = this.getFileType(name),
                            (
                                <a className={`table-border d-block ${this.state.selected === name ? 'font-weight-bold' : ''}`} onClick={() => this.handleVideoOrFolderClick(name)}>
                                    <div className={this.state.selected === name ? 'songNameDivBackground' : 'songNameBackground'}>
                                        <div className="Track">
                                            <div className={(!this.isVideoFile(name)) ? "Track-imageFolder" : (fileType == "mp3" || fileType == "m4a" ? 'Track-image' : 'Track-imageVideo')} />
                                            <div className="ml-2 mt-3 songNameTitle">{name}</div>
                                        </div>
                                    </div>
                                </a>)
                        ))}</div>
                </div>
            );

        }
    }

    getFileType = (filePath) => {
        if (filePath !== null) {
            const fileType = filePath.split('.').pop();
            return fileType.toLowerCase();
        }
    }

    switchAudioVideo = () => {
        let fileType;
        if (this.state.relativePath !== "") {
            fileType = this.getFileType(this.state.relativePath);
        }
        else {
            fileType = this.getFileType(this.state.filteredList[0]);
        }
        switch (fileType) {
            case "mp4":
            case 'mov':
                return (<VideoPlayer relativePath={this.state.relativePath} relativeWebMPath={this.state.relativeWebMPath} />);
                break;
            case "mp3":
            case 'm4a':
                return (<AudioPlayer relativePath={this.state.relativePath} />);
                break;
            default:
                return "";
                break;
        }

    }
    render() {
        const fileType = this.getFileType(this.state.relativePath);

        if (this.state.filteredList != null) {

            return (
                <div className="content-section pt-3 pt-sm-5 pb-3 pb-sm-5">
                    <AjaxLoader isOpen={this.props.isLoading} />
                    <div className="breadcrumb-link"><Link className="pr-2" to={this.state.path.search('Vanchan') === -1 ? process.env.PUBLIC_URL + "/Gallery?Type=Videos" : process.env.PUBLIC_URL + "/Vanchan?Type=Videos"}>Videos</Link> <FontAwesomeIcon icon={faChevronRight} /> <span className="pl-2">{this.state.directoryName[1]}</span></div>
                    <If condition={this.state.path.search('Vanchan') === -1}><GalleryHeader isActive='2' /></If>
                    {this.state.filteredList.length > 0 ?
                        <React.Fragment>
                            <div className="audioDirectoryName mb-4 mt-3">
                                <div className="d-flex align-items-center">
                                    <If condition={this.state.foundThumbnailPath}>
                                        <Media className="mr-3 directoryStyle" src={process.env.PUBLIC_URL + `/Media/` + this.state.directoryName[0] + `/Thumbnails/${this.state.directoryName[1]}.jpg`} />
                                        <b className="ml-3"> {this.state.directoryName[1]}</b>
                                    </If>
                                </div>
                            </div>
                            <Row>
                                <Col xl={6} lg={fileType === "mp4" || fileType === "mov" ? 6 : 12} className={fileType === "mp3" && "mt-3 d-flex flex-column align-items-center justify-content-center"}>
                                    {this.switchAudioVideo()}
                                </Col>
                                <Col xl={6} className="mb-2">
                                    {this.showVideoFiles()}
                                </Col>
                            </Row>
                        </React.Fragment>
                        :
                        !this.props.search &&
                        <div className="d-flex justify-content-center pt-4 empty-folder">
                            <div className="text-center w-100">
                                <div className="empty-message">Empty Folder</div>
                                <div className="root-header d-flex align-items-center py-2 justify-content-center">
                                    <FontAwesomeIcon className="fa-w-14" icon={faChevronLeft} />
                                    <div className="pl-1" onClick={this.loadFolderContents}>Go Back</div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

            )


        }
        else {
            if (!this.props.isLoading) {
                return (<NoItemFound />);
            }
            else {
                return (<AjaxLoader isOpen={this.props.isLoading} />);
            }

        }

    }
}

const mapStateToProps = (state) => {
    return {
        videoFiles: state.VideoReducer.VideoFilesList,
        isLoading: state.VideoReducer.isLoading,
        search: state.SearchReducer.search,
        videoDirectoryName: state.VideoReducer.videoDirectoryName,
        videoGalleryDirPath: state.VideoGalleryReducer.VideoGalleryDirPath,
    }
};

const mapDispatchToProps = dispatch => ({
    getVideoFiles: (selectedFolderPath) => {
        dispatch(getVideoFiles(selectedFolderPath));

    }, getVideoDirectoryName: (videoFolderPath) => {
        dispatch(getVideoDirectoryName(videoFolderPath));
    }
}
);

export default connect(mapStateToProps, mapDispatchToProps)(VideoSongs);

